/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components'
import PropTypes from 'prop-types'

const [green, yellow, red] = ['#28D999', '#FDC830', '#ED2C38']

export const SlaContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`

export const SlaBadge = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 10px;
    background-color: ${({ daysDiff }) => daysDiff >= 20 ? red : daysDiff >= 17 ? yellow : daysDiff <= 16 && green};
`

export const SlaText = styled.span`
    color: #53565A;
    font-weight: 700;
    font-size: 14px;
`